import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text, HorizontalDivider } from '@dkrm/ui-kit-basic';
import { View, TouchableWithoutFeedback } from 'react-native';
import { ChevronMore, ChevronLess } from '@dkrm/icons';
import cStyles, { stylePropTypes } from '@dkrm/general-libs/theme/styles';
export default class SectionCollapseItem extends Component {
  constructor(props) {
    super(props);
    this.handleCollapseToggle = () => {
      const {
        onCollapse,
        item
      } = this.props;
      const {
        isCollapsed
      } = this.state;
      this.setState({
        isCollapsed: !isCollapsed
      });
      onCollapse(item);
    };
    this.state = {
      isCollapsed: props.isCollapsed
    };
  }
  getTitleContainerStyle() {
    const {
      align,
      titleContainerStyle
    } = this.props;
    const headerStyles = [cStyles.flexDirRow, cStyles.pvxl];
    if (align === 'left') {
      headerStyles.push({
        justifyContent: 'space-between'
      });
    }
    headerStyles.push(titleContainerStyle);
    return headerStyles;
  }
  getTitleStyle() {
    const {
      align,
      titleStyle
    } = this.props;
    const titleStyles = [cStyles.subtitlem];
    if (align === 'left') {
      titleStyles.push(cStyles.prxl);
    } else {
      titleStyles.push(cStyles.plxl);
    }
    titleStyles.push(titleStyle);
    return titleStyles;
  }
  getContentStyle() {
    const {
      align,
      contentStyle,
      item: {
        ContentElement
      }
    } = this.props;
    const contentStyles = [cStyles.contentm, cStyles.ptxs, cStyles.pbxl];
    if (align === 'left') {
      contentStyles.push(cStyles.prxxxl);
    } else {
      contentStyles.push(cStyles.plxxxl);
    }
    contentStyles.push(contentStyle);
    return ContentElement ? contentStyles.pop() : contentStyle;
  }
  renderIcon() {
    const {
      iconColor,
      iconSize,
      CollapsedIconComponent,
      ExpandedIconComponent
    } = this.props;
    const {
      isCollapsed
    } = this.state;
    const IconComponent = isCollapsed ? CollapsedIconComponent : ExpandedIconComponent;
    return /*#__PURE__*/React.createElement(IconComponent, {
      theme: iconColor,
      size: iconSize
    });
  }
  renderContent() {
    const {
      item: {
        content,
        ContentElement
      }
    } = this.props;
    const contentStyle = this.getContentStyle();
    if (ContentElement) {
      return /*#__PURE__*/React.createElement(View, {
        style: contentStyle
      }, ContentElement);
    }
    return /*#__PURE__*/React.createElement(Text, {
      style: contentStyle
    }, content);
  }
  renderTitle() {
    const {
      item: {
        title,
        TitleElement
      }
    } = this.props;
    const titleStyle = this.getTitleStyle();
    if (TitleElement) {
      return /*#__PURE__*/React.createElement(View, {
        style: titleStyle
      }, TitleElement);
    }
    return /*#__PURE__*/React.createElement(Text, {
      style: titleStyle
    }, title);
  }
  render() {
    const {
      isCollapsed
    } = this.state;
    const {
      align,
      containerStyle,
      shouldShowSeparator,
      separatorProps
    } = this.props;
    return /*#__PURE__*/React.createElement(View, {
      style: containerStyle
    }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      onPress: this.handleCollapseToggle
    }, /*#__PURE__*/React.createElement(View, {
      style: this.getTitleContainerStyle()
    }, align === 'right' && this.renderIcon(), this.renderTitle(), align === 'left' && this.renderIcon())), shouldShowSeparator && /*#__PURE__*/React.createElement(HorizontalDivider, separatorProps), !isCollapsed && this.renderContent());
  }
}
SectionCollapseItem.defaultProps = {
  CollapsedIconComponent: ChevronMore,
  ExpandedIconComponent: ChevronLess,
  isCollapsed: true,
  shouldShowSeparator: false,
  align: 'right',
  iconColor: 'black',
  iconSize: 25,
  onCollapse: () => {},
  titleContainerStyle: {},
  titleStyle: {},
  contentStyle: {},
  containerStyle: null,
  separatorProps: {}
};
SectionCollapseItem.propTypes = process.env.NODE_ENV !== "production" ? {
  item: PropTypes.shape({
    title: PropTypes.string,
    TitleElement: PropTypes.element,
    content: PropTypes.string,
    ContentElement: PropTypes.element
  }).isRequired,
  isCollapsed: PropTypes.bool,
  shouldShowSeparator: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right']),
  onCollapse: PropTypes.func,
  CollapsedIconComponent: PropTypes.elementType,
  ExpandedIconComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  iconSize: PropTypes.number,
  titleContainerStyle: stylePropTypes,
  titleStyle: stylePropTypes,
  contentStyle: stylePropTypes,
  containerStyle: stylePropTypes,
  separatorProps: PropTypes.shape()
} : {};